<div class="dashboard-wrapper">
  <!-- Dashboard Title -->
  <h1 class="h1-heading">{{ title }}</h1>

  <!-- Filters Section -->
  <app-card>
    <div class="filter-area">
      <ng-content select="[appDashboardFilter]"></ng-content>
    </div>
  </app-card>

  <!-- Table/Data Section -->
  <app-card>
    <!-- No Data Message -->
    @if (!hasData) {
      <div class="center-container no-data-container">
        {{ noDataMessage }}
      </div>
    }

    <!-- Table and Pagination -->
    @if (hasData) {
      <div class="table-area">
        <ng-content select="[appDashboardTable]"></ng-content>
      </div>
      <div class="pagination-area center-container">
        <ng-content select="[appDashboardPagination]"></ng-content>
      </div>
    }
  </app-card>
</div>